import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import headImg from '../../assets/icon-user.png';

export const Root = styled(Box)({
    '& .wapper': {
        marginTop: '14px',
        '& .info': {
            width: '30%',
            backgroundColor: '#ffffff',
            marginRight: '16px',
            padding: '0 16px',
            '& .user': {
                marginTop: '16px',
            },
            '& .username': {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#005e96',
            },
            '& .profession': {
                fontSize: '16px',
                color: '#9b9b9b',
            },
            '& .avatar': {
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: `url(${headImg}) no-repeat center top/cover`,
            },
            '& .line': {
                width: '100%',
                height: '1px',
                backgroundColor: '#d8d8d8',
                marginTop: '29px',
            },
            '& .font-btn': {
                fontSize: '14px',
                marginRight: '30px',
                margin: '14px 0',
            },
        },
        '& .details': {
            width: '70%',
            backgroundColor: '#ffffff',
            padding: '16px',
            '& .title': {
                color: '#212C31',
                fontSize: '16px',
                fontWeight: 'bold',
                marginTop: '19px',
            },
            '& .line': {
                width: '100%',
                height: '1px',
                backgroundColor: '#F3F3F3',
                margin: '15px 0',
            },
            '& .textField': {
                width: '46%',
                marginRight: '30px',
            },
            '& .iconTextField': {
                width: '46%',
                marginRight: '30px',
                display: 'inline-flex',
                '& .icon': {
                    fontSize:'20px',
                    marginRight:'10px',
                },
                '& .rateText': {
                    width: '30%',
                    marginRight: '10px',
                },
            },
            '& .workWapper': {
                fontSize: '14px',
                margin: '10px 0',
            },
        },
    }
});